// declare const Buffer
// import { Buffer } from 'buffer/';
// import { DataTablesModule } from 'angular-datatables';
import {
  Component,
  OnInit,
  OnChanges,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { QuestionnaireService } from "app/services/questionnaire.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HelperService } from "app/services/helper.service";
import { TosterMessageService } from "app/services/toster-message.service";
import { NgForm } from "@angular/forms";
import { QuestionBankService } from "../../services/question-bank.service";
import { FormGroup, FormBuilder, FormArray } from "@angular/forms";

// import { config, S3 } from 'aws-sdk';
import { UploadService } from "app/services/upload.service";

@Component({
  selector: "app-question-bank-add-new-mcq-modal",
  templateUrl: "./question-bank-add-new-mcq-modal.component.html",
  styleUrls: ["./question-bank-add-new-mcq-modal.component.scss"],
  providers: [QuestionBankService],
})
export class QuestionBankNewQueAddMcqComponent implements OnInit, OnChanges {
  isHide: any = 1;

  base64Image: string | undefined;
  selectedImage: any = {};

  answerForm: FormGroup;
  sortOrder: number = 0;
  entity: any = {};
  correctAnsweIndex: number;

  public masterData: any = {};
  formData = {
    correct_answer: "",
    correct_all_answer: "",
    answer: "",
    media_type: "",
    media_link: "",
    marks: "",
    auto_id: "",
  };

  selectedFile: any = {};
  isLoading = false;

  isEdit: number;
  @Output() tableReload: EventEmitter<any> = new EventEmitter();
  @Input() auto_id: number;
  @Input() header_id_2: number;

  @ViewChild("form") form: NgForm;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = +this.helperService.getSelectedCompanyId();

  constructor(
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private QuestionBankService: QuestionBankService,
    private frmbuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private UploadService: UploadService
  ) { }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }


  
  onMediaTypeChange($event) {
    if ($event.target.value !== "1") {
      this.isHide = 0;
    } else {
      this.isHide = 1;
    }
  }



  ngOnInit() {
    this.auto_id = Number(localStorage.getItem("question-bank-edit-auto-id"));
    localStorage.removeItem("question-bank-edit-auto-id");
    this.header_id_2 = Number(localStorage.getItem("question-bank-edit-header-id"));
    localStorage.removeItem("file");

    setInterval(()=> { 
      if(localStorage.getItem("file")){
        this.isLoading = false;
      }
    }, 1500);
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.isLoading = false;
  }


  async onFileSelected(event: any) {
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
    const response = await this.UploadService.uploadFile(this.selectedFile);
  }


  addMCQAnswers(formData: any) {
    const requestData = {
      correct_answer: formData.correct_answer,
      correct_all_answer: formData.correct_all_answer,
      answer: formData.answer,
      media_type: formData.media_type,
      // media_link: localStorage.getItem("file"),
      media_link: formData.media_type === '3' ? formData.media_link : localStorage.getItem("file"),
      sort_order: formData.sort_order,
      marks: formData.marks,
      companySystemID: this.companySystemID,
      header_id: this.auto_id,
      header_detail_id: this.header_id_2,
    };
    localStorage.removeItem("file");

    let that = this;
    that.masterData.companySystemID = that.companySystemID;
    that.masterData.header_id = that.auto_id;
    that.QuestionBankService.createNewMCQQuestionBank()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          console.log(resp);
          that.masterData = {};
          that.successMsg = "";
          that.successMsg = "Successfully Record Added";
          that.showSuccessHtml();
          this.tableReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(
              error.data.message
            );
            that.showErrorHtml();
          }
          this.tableReload.emit();
        }
      );
    this.tableReload.emit();
  }
}



// WEBPACK FOOTER //
// /app/src/app/competancy/question-bank-add-new-mcq-modal/question-bank-add-new-mcq-modal.component.ts